import { ScrollTop } from '@/components/element/ScrollTop';
import { QuotationTaskFileEditForm } from '@/components/features/tasks/quotation/[quotation_task_id]/QuotationTaskFileEditForm';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useCurrentQuotationTask } from '@/providers/QuotationTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

export const BackofficeQuotationTaskFiles = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { sales_order_id } = useParams();
  const { quotationTask: task } = useCurrentQuotationTask();

  useEffect(() => setTitle(`見積書等ファイル一覧`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `見積申請タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/quotation_tasks` },
        {
          label: `見積申請タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${sales_order_id}/quotation_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <QuotationTaskFileEditForm />
    </WorkspaceLayout>
  );
};
